import Api from "../api";
let uri = '/api/ed/plantilla/meta';
let uriUpload = 'api/ed/meta/media/';
let uriGallery = 'api/ed/plantilla/gallery'

export const getPlantilla = (data) => {
    return Api.getInstance().executeQuery(`${uri}/list`, data)
        .then((resp) => resp.data)
        .catch((error) =>
            console.log(error)
        );
}

export const adminPlantilla = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
        .then((resp) => resp)
        .catch((error) =>
            console.log(error)
        );
}

export const uploadMedia = (data) => {
    return Api.getInstance().executeMultipart(`${uriUpload}upload`, data)
        .then((resp) => resp)
        .catch((error) => error);
}

export const metaMediaUpsert = (data) => {
    return Api.getInstance().executeQuery(`${uriUpload}upsert`, data)
        .then((resp) => resp)
        .catch((error) => error);
}

export const getBibliotecaPlantillas = (data) => {
    return Api.getInstance().executeQuery(`${uriGallery}`, data)
        .then((resp) => resp.data)
        .catch((error) =>
            console.log(error)
        );
}

export const adminBibliotecaPlantilla = (data) => {
    return Api.getInstance().executeQuery(`${uriGallery}/upsert`, data)
        .then((resp) => resp)
        .catch((error) =>
            console.log(error)
        );
}


